import { InjectionToken } from "@angular/core";
import { PurchaseOrdersPort } from "./purchase-orders.port";
export const PURCHASE_ORDERS_PORT = new InjectionToken<PurchaseOrdersPort>("PURCHASE_ORDERS_PORT");
